{% block sw_cms_block_acris_blog_image_slider %}
    <div class="sw-cms-preview-acris-blog-image-slider">
        <mt-icon
                name="regular-chevron-left"
                size="20"
        />
        <img
                :src="assetFilter('/administration/administration/static/img/cms/preview_mountain_small.jpg')"
                alt=""
        >
        <mt-icon
                name="regular-chevron-right"
                size="20"
        />
    </div>
{% endblock %}
